import React from 'react';
import Welcome from './Welcome';
import { useNavigationContext } from '../../../contexts/NavigationContext';
import Navbar from '../common/navbar/Navbar';
import ResourcePage from './resource/ResourcePage';
import ProgramPage from './program/ProgramPage';
import AnalyticsPage from '../analytics/AnalyticsPage';
import './BanquetCeleste.scss';
import { CONSTANT } from '../../../utils/constants';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (
    <div className="flex flex-row h-screen w-screen">
      <div className="min-w-64 w-64">
        <Navbar />
      </div>
      <div className="w-full h-auto overflow-scroll">
        <ProgramPage isActive={navigationContext.acitveAppKey === 'program'} />
        <ResourcePage isActive={navigationContext.acitveAppKey === 'resource'} />

        <AnalyticsPage
          isActive={navigationContext.acitveAppKey === 'analytics'}
          scope={'banquetceleste'}
          config={CONSTANT.banquetceleste.analytics}
        />

        <Welcome isActive={!navigationContext.acitveAppKey} />
      </div>
    </div>
  );
}

export default Home;
